import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addCoustomerAddresses,
  updateCustomerAddresses,
} from "../../../../redux/api/website/CoustomerAddressesApi";
import { toast } from "react-toastify";
import {
  CitySelect,
  CountrySelect,
  StateSelect,
  LanguageSelect,
  RegionSelect,
  PhonecodeSelect,
} from "react-country-state-city";
import { GetCountries, GetState, GetCity } from "react-country-state-city";
import { useDispatch } from "react-redux";
import {
  fetchCustomerAddresses,
  getCoustomerAdderss,
} from "../../../../redux/reduxApi/website/CoustomerAdderssrapi";

export default function BillingAddress() {
  const location = useLocation();
  const dispatch = useDispatch();
  const address = location.state;
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    customerId: localStorage.getItem("customerId"),
    // firstName: "",
    // lastName: "",
    companyName: "",
    country: "",
    address: "",
    town: "",
    city: "",
    state: "",
    postalCode: "",
    phone: "",
    // email: "",
    rowId: "",
    addressType: "Shipping",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const fetchData = async () => {
      // Country
      if (formData.country && !selectedCountry) {
        const allCountries = await GetCountries();
        const matched = allCountries.find((c) => c.iso2 === formData.country);
        if (matched) setSelectedCountry(matched);
      }

      // State
      if (formData.state && selectedCountry && !selectedState) {
        const allStates = await GetState(selectedCountry.id);
        const matched = allStates.find((s) => s.state_code === formData.state);
        if (matched) setSelectedState(matched);
      }

      // City
      if (formData.city && selectedCountry && selectedState && !selectedCity) {
        const allCities = await GetCity(selectedCountry.id, selectedState.id);
        const matched = allCities.find((c) => c.name === formData.city);
        if (matched) setSelectedCity(matched);
      }
    };

    fetchData();
  }, [formData, selectedCountry, selectedState]);

  // useEffect(() => {
  //     const fetchCountry = async () => {
  //       if (formData.country) {
  //         const countries = await GetCountries();
  //         const match = countries.find((c) => c.iso2 === formData.country);
  //         if (match) {
  //           // ✅ wrap in label/value format to satisfy react-select internal logic
  //           setSelectedCountry({
  //             ...match,
  //             label: match.name,
  //             value: match.iso2,
  //           });
  //         }
  //       }
  //     };
  //     fetchCountry();
  //   }, [formData.country]);

  useEffect(() => {
    if (address?.rowId) {
      console.log(address, "datatodisplay");
      // Initialize form data with existing address
      setFormData({
        ...formData,
        // firstName: address.firstName || "",
        // lastName: address.lastName || "",
        companyName: address.companyName || "",
        country: address.country || "",
        address: address.address || "",
        town: address.town || "",
        city: address.city || "",
        state: address.state || "",
        postalCode: address.postalCode || "",
        phone: address.phone || "",
        // email: address.email || "",
        rowId: address.rowId,
        addressType: address.addressType || "Shipping",
      });

      // You would need to implement logic to set initial country/state/city based on existing values
      // This might require API calls or a country/state/city data source
    }
  }, [address]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (address?.rowId) {
        await updateCustomerAddresses(formData);
        toast.success("Address updated successfully");
        navigate("/account/edit-address");
        dispatch(getCoustomerAdderss());
      } else {
        await addCoustomerAddresses(formData);
        toast.success("Address added successfully");
        navigate("/account/edit-address");
        dispatch(getCoustomerAdderss());
      }
      // Reset form after submission
      setFormData({
        ...formData,
        // firstName: "",
        // lastName: "",
        companyName: "",
        country: "",
        address: "",
        town: "",
        city: "",
        state: "",
        postalCode: "",
        phone: "",
        // email: "",
        addressType: "Shipping",
      });
      setSelectedCountry(null);
      setSelectedState(null);
      setSelectedCity(null);
    } catch (error) {
      console.error(error);
      toast.error("Error processing address");
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg lg:mt-8 md:mt-8 sm:mt-0 border shadow-md max-w-4xl mx-auto">
      <div className="border-b pb-4 mb-6">
        <h1 className="text-[40px] text-center mb-2 font-semibold text-gray-800">
          {address?.rowId ? "Edit Address" : "Add New Address"}
        </h1>
      </div>

      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* First Name */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              First Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              required
            />
          </div> */}

          {/* Last Name */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Last Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              required
            />
          </div> */}
          <div className="col-span-full">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Company Name (optional)
            </label>
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
            />
          </div>
          {/* Street Address */}
          <div className="col-span-full">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Street Address <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              required
            />
          </div>

          {/* Country Selection */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Country <span className="text-red-500">*</span>
            </label>
            <CountrySelect
              containerClassName="w-full"
              inputClassName="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              onChange={(country) => {
                console.log(country, "country");
                setSelectedCountry(country);
                setFormData((prev) => ({ ...prev, country: country.iso2 }));
                setSelectedState(null);
                setSelectedCity(null);
              }}
              placeHolder="Select Country"
              defaultValue={selectedCountry}
              //   value={selectedCountry || formData.country}
              required
            />
          </div>

          {/* State Selection */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
            Province  <span className="text-red-500">*</span>
            </label>
            <StateSelect
              countryid={selectedCountry?.id}
              containerClassName="w-full"
              inputClassName="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              onChange={(state) => {
                setSelectedState(state);
                setFormData((prev) => ({ ...prev, state: state.state_code }));
                setSelectedCity(null);
              }}
              placeHolder="Select Province"
              //   value={formData.state}
              defaultValue={selectedState}
              disabled={!selectedCountry}
              required
            />
          </div>

          {/* City Selection */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              City <span className="text-red-500">*</span>
            </label>
            <CitySelect
              countryid={selectedCountry?.id}
              stateid={selectedState?.id}
              containerClassName="w-full"
              inputClassName="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              onChange={(city) => {
                setSelectedCity(city);
                setFormData((prev) => ({ ...prev, city: city.name }));
              }}
              placeHolder="Select City"
              //   value={formData.city}
              defaultValue={selectedCity}
              disabled={!selectedState}
              required
            />
          </div>

          {/* Address Type */}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Postal Code <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="postalCode"
              value={formData.postalCode}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              required
            />
          </div>

          {/* Company Name */}


          {/* Town */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Town <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="town"
              value={formData.town}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              required
            />
          </div> */}
                {/* Phone */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Phone <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              required
            />
          </div>

          {/* postal Code */}
           <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Address Type <span className="text-red-500">*</span>
            </label>
            <select
              name="addressType"
              value={formData.addressType}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              required
            >
              <option value="Shipping">Shipping</option>
              <option value="Billing">Billing</option>
            </select>
          </div>

      

          {/* Email */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              required
            />
          </div> */}
        </div>

        <div className="mt-8">
          <button
            type="submit"
            className="w-full bg-orange-500 hover:bg-orange-600 text-white px-4 py-[13px] rounded-xl font-medium transition-colors"
          >
            {address?.rowId ? "Update Address" : "Save Address"}
          </button>
        </div>
      </form>
    </div>
  );
}
